import { Middleware } from '@nuxt/types';
import { usePageStore } from '~/stores/page';
import { Logger } from '~/helpers/logger';
import { RoutableInterface } from '~/modules/GraphQL/types';
import { getLocalizedPath } from '~/helpers/getLocalizedPath';

const urlResolverMiddleware : Middleware = async (context) => {
  const pageStore = usePageStore(context.$pinia);
  const { path } = context.route;

  const clearUrl = path.replace(/[a-z]+\/[cp|]\//gi, '').replace(`/${context.i18n.locale}`, '');

  Logger.debug('middleware/url-resolver', clearUrl);

  const { data, errors } = await context.app.$vsf.$magento.api.route(clearUrl);

  Logger.debug('middleware/url-resolver/result', { data, errors });

  const results: RoutableInterface | null = data?.route ?? null;

  if (!results || errors?.length) {
    return context.error({ statusCode: 404 });
  }

  if (results && (results.redirect_code === 302 || results.redirect_code === 301)) {
    return context.redirect(results.redirect_code, getLocalizedPath(results.relative_url, context.i18n));
  } else {
    pageStore.$patch((state) => {
      state.routeData = results;
    });
  }
};

export default urlResolverMiddleware;
